/**
 * @generated SignedSource<<78fb7922485905788d94b3a5508bed78>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type NoticeDismissInput = {|
  clientMutationId?: ?string,
  id: string,
|};
export type ConferenceAnnouncementNoticeNoticeDismissMutation$variables = {|
  input: NoticeDismissInput,
|};
export type ConferenceAnnouncementNoticeNoticeDismissMutation$data = {|
  +noticeDismiss: ?{|
    +notice: ?{|
      +dismissedAt: ?any,
      +id: string,
    |},
  |},
|};
export type ConferenceAnnouncementNoticeNoticeDismissMutation = {|
  response: ConferenceAnnouncementNoticeNoticeDismissMutation$data,
  variables: ConferenceAnnouncementNoticeNoticeDismissMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "NoticeDismissPayload",
    "kind": "LinkedField",
    "name": "noticeDismiss",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Notice",
        "kind": "LinkedField",
        "name": "notice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dismissedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConferenceAnnouncementNoticeNoticeDismissMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConferenceAnnouncementNoticeNoticeDismissMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "51308a50b213acf1c18efb0842727e90",
    "id": null,
    "metadata": {},
    "name": "ConferenceAnnouncementNoticeNoticeDismissMutation",
    "operationKind": "mutation",
    "text": "mutation ConferenceAnnouncementNoticeNoticeDismissMutation(\n  $input: NoticeDismissInput!\n) {\n  noticeDismiss(input: $input) {\n    notice {\n      id\n      dismissedAt\n    }\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "d62c68d2c9df53947a554c03eb322450";

module.exports = ((node/*: any*/)/*: Mutation<
  ConferenceAnnouncementNoticeNoticeDismissMutation$variables,
  ConferenceAnnouncementNoticeNoticeDismissMutation$data,
>*/);
